import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import SwitchUI from '../../../widgets/action/SwitchUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import './ConditionSubsequentStatusPage.css'

const ConditionSubsequentStatusPageUI = ({ context, errorList, accountCsStatusList, fileNameSet, onRefreshClick, checked, onShowLoans, onDownloadClick }) =>
  <SuperUserHomePageUI context={context} className='pg_su_cs_lst' topnav='accounts' dimension='w1600'
    headerText='Condition subsequent non-compliance' centered={!accountCsStatusList && !errorList}
    page='csStatus'
  >
    {
      !accountCsStatusList && !errorList &&
      <SpinnerComponentUI />
    }
    <div>
      {
        accountCsStatusList &&
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
              <IconButtonUI icon='icon-download' onClick={onDownloadClick} label='Download' />
              <span className='g_m_left_100 g_large'><b>Condition Subsequent Compliance</b></span>
            </span>
          }
          right={
            <span className='g_flex_h'>
              <span className='g_muted g_small g_m_right_50'>
                Loan breakup
              </span>
              <SwitchUI
                checked={checked}
                onChange={onShowLoans}
              />
            </span>
          }
        />
      }
      {
        accountCsStatusList && accountCsStatusList.length !== 0 &&
        <ConditionSubsequentRemarksUI
          context={context} accountCsStatusList={accountCsStatusList}
          fileNameSet={fileNameSet}
          onRefreshClick={onRefreshClick}
          checked={checked}
        />
      }

      {
        accountCsStatusList && accountCsStatusList.length === 0 &&
        <div className='g_m_top_200'>
          <EmptyListUI
            context={context}
            createEnabled={false}
            createDisabledMessageLabel='No remarks yet'
          />
        </div>
      }
    </div>
  </SuperUserHomePageUI>

const ConditionSubsequentRemarksUI = ({ context, accountCsStatusList, fileNameSet, checked }) =>
  <CardUI>
    <table>
      <thead className='g_sticky'>
        <tr>
          <th>Account</th>
          {
            checked &&
            <th className='g_p_left_100'>Loan</th>
          }
          <th className='g_p_left_100'>Condition</th>
          <th className='g_p_left_100'>Remarks</th>
        </tr>
      </thead>
      <tbody>
        {
          accountCsStatusList.map((account, i) =>
            <React.Fragment key={i}>
              {
                account.loanCsStatusList.map((loan, j) =>
                  <React.Fragment key={j}>
                    {
                      !checked && loan.csStatusList.filter(cs => cs.internalRemarks).map((cs, k) =>
                        <tr key={k}>
                          <td className='g_no_wrap_2'>
                            {account.accountName}
                          </td>
                          <td className='g_p_left_100'>
                            {cs.fileName}
                          </td>
                          <td className='g_p_left_100'>
                            {cs.internalRemarks}
                          </td>
                        </tr>
                      )
                    }

                    {
                      checked && loan.csStatusList.filter(cs => cs.internalRemarks).map((cs, k) =>
                        <tr key={k}>
                          <td className='g_no_wrap_2'>
                            {account.accountName}
                          </td>
                          <td className='g_p_left_100'>
                            <Link to={`/su/loans/${loan.loanId}/compliance/cs`}>
                            {loan.loanName}</Link>
                          </td>
                          <td className='g_p_left_100'>
                            {cs.fileName}
                          </td>
                          <td className='g_p_left_100'>
                            {cs.internalRemarks}
                          </td>
                        </tr>
                      )
                    }

                  </React.Fragment>
                )
              }
            </React.Fragment>
          )
        }

      </tbody>
    </table>
  </CardUI>

export default ConditionSubsequentStatusPageUI
